export const INSTANCE_ORDER = "instanceOrder";
export const INSTANCE_ID = "__instanceId";
export const NEW_INSTANCE = "newInstance";
export const SYSTEM_USER_EMAIL = "system@graphiteconnect.com";
